import { render, staticRenderFns } from "./RecapBlockContainer.vue?vue&type=template&id=e9c7f476&scoped=true&"
import script from "./RecapBlockContainer.vue?vue&type=script&lang=js&"
export * from "./RecapBlockContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c7f476",
  null
  
)

export default component.exports